<template>

</template>
<script>
import '../../assets/css/index-c925edae.css'
import '../../assets/css/514.cbfba8eb.css'
export default {
  data() {
    return {
      list: [],
    }
  },
  created() {
    this.getlist()
  },
  methods: {
    async getlist() {
      param.append('file', file.file)
      const { data } = await this.$http.post('/getmyordering')
      if (data) {
        this.list = data.data
      }
    },
  },
}
</script>
<style scoped lang="less"></style>
